export default "__VITE_ASSET__CpDYQWEu__"